<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}
body,
html {
  font-family: "微软雅黑", "Microsoft Yahei";
}
li,
ul {
  list-style: none;
}
.clear {
  clear: both;
}
a {
  -webkit-appearance: none;
  -webkit-tap-highlight-color: rgba(255, 0, 0, 0);
  resize: none;
  border-radius: 0;
  font-family: "微软雅黑", "Microsoft Yahei";
  text-decoration: none;
  cursor:pointer;
}
button,
input,
select,
textarea {
  -webkit-appearance: none;
  -webkit-tap-highlight-color: rgba(255, 0, 0, 0);
  box-sizing: border-box;
  resize: none;
  border-radius: 0;
  font-family: "微软雅黑", "Microsoft Yahei";
}
img {
  border: none;
}
* {
  padding: 0;
  margin: 0;
  outline: 0;
  -webkit-tap-highlight-color: transparent;
  -webkit-appearance: none;
}
.wh1200 {
  max-width: 1200px;
  margin: 0 auto;
}
::-webkit-scrollbar-track-piece {
  background-color: #fff;
}
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
::-webkit-scrollbar-thumb {
  background-color: #cc0001;
  background-clip: padding-box;
  min-height: 28px;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}
::-webkit-scrollbar-thumb:hover {
  background-color: rgba(204, 0, 1, 0.5);
}
input::-webkit-input-placeholder {
  color: #888888;
}
input:-moz-placeholder {
  color: #888888;
}
input::-moz-placeholder {
  color: #888888;
}
.time-01s {
  -webkit-transition: all 0.1s ease-out;
  -khtml-transition: all 0.1s ease-out;
  -moz-transition: all 0.1s ease-out;
  -o-transition: all 0.1s ease-out;
  transition: all 0.1s ease-out;
}
.time-02s {
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}
.time-03s {
  -webkit-transition: all 0.3s ease-out;
  -khtml-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
}
.time-04s {
  -webkit-transition: all 0.4s ease-out;
  -khtml-transition: all 0.4s ease-out;
  -moz-transition: all 0.4s ease-out;
  -o-transition: all 0.4s ease-out;
  transition: all 0.4s ease-out;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.swiper-pagination-current {
  color: #fff;
  font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue